// extracted by mini-css-extract-plugin
module.exports = {"mrg":"HistoryCheckTheme_mrg__DROZr","wrapper":"HistoryCheckTheme_wrapper__2g2Tu","wrapper__button":"HistoryCheckTheme_wrapper__button__2QyNM"};